import { alpha, Theme } from '@mui/material';
import { useBlendColors } from 'hooks/useDesign';

export default {
    container: {
        overflow: 'auto',
        flexGrow: 1,
        position: 'relative',
    },

    chatList: {
        py: 2,
        px: '14px',
    },
    chatItem: {
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.08),
        p: 1,
        borderRadius: '4px',
        '&:hover': {
            cursor: 'pointer',
            borderColor: (theme: Theme) => useBlendColors(alpha(theme.palette.primary.main, 0.6)),
            backgroundColor: (theme: Theme) => useBlendColors(alpha(theme.palette.primary.main, 0.08)),
        },
    },
};
